"use client";
import { HTMLProps, useCallback, useMemo } from "react";
import { useAppStore } from "@/store/app";
import { getLang } from "@/utils/selectors";
import { SvgIconCaret, SvgIconInfo } from "@/components/common/Svg";
import Markdown from "@/components/common/Markdown";
import Button from "@/components/common/Button";
import Tooltip from "@/components/common/Tooltip";
import styles from "../Map.module.css"

export interface MapHeaderProps extends HTMLProps<HTMLElement> {};

export default function MapHeader({} : MapHeaderProps) {
	const controls = useAppStore(store => store.controls);
	const showMobileControls = useAppStore(store => store.showMobileControls);
	const setShowMobileControls = useAppStore(store => store.setShowMobileControls);

	const titleStrings = useMemo(() => ({
		view: getLang("view", controls.view),
		stat: getLang(controls.view, controls.stat, "title"),
		geo: getLang("geo", controls.geo),
		year: controls.year.includes("avg")
			? getLang("year", controls.year, "title")
			: getLang("year", controls.year),
	}), [controls]);

	const title = useMemo(() =>
		getLang("map", "title", titleStrings)
		// isStatYearly(controls.stat)
		// 	? getLang("map", "title", titleStrings)
		// 	: getLang("map", "title", titleStrings)
	, [titleStrings]);

	const subtitle = useMemo(() =>
		getLang(controls.view, controls.stat, "subtitle")
	, [controls]);

	const tooltip = useMemo(() =>
		getLang(controls.view, controls.stat, "tooltip")
	, [controls]);

	const handleMobileControlsToggle = useCallback(() => {
		setShowMobileControls(!showMobileControls)
	}, [showMobileControls, setShowMobileControls]);

	return (
		<header
			className={styles.MapHeader}
		>
			<Button
				after={
					<SvgIconCaret
						type={showMobileControls ? "up" : "down"}
					/>
				}
				className={styles.MapHeaderMobileControlsToggle}
				onClick={handleMobileControlsToggle}
			>
				{getLang("controls", "toggle", showMobileControls ? "hide" : "show")}
			</Button>
			<h2
				className={styles.MapHeaderTitle}
			>
				<span
					title={title}
				>
					{title}
				</span>
				<Tooltip
					// hasIcon={true}
					inner={tooltip}
					footer={getLang("stat", "tooltip", "footer")}
					className={styles.MapHeaderTitleTooltip}
					TriggerProps={{
						"aria-label": "tooltip toggle"
					}}
				>
					<SvgIconInfo
						className={styles.MapHeaderTitleTooltipIcon}
					/>
				</Tooltip>
			</h2>
			<Markdown
				title={subtitle}
				className={styles.MapHeaderSubtitle}
			>
				{subtitle}
			</Markdown>
		</header>
	)
}